export default "__VITE_ASSET__CDZBcpzC__"